import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
} from "@mui/material";
import PasswordField from "./PasswordField";
import apiClient from "./utils/apiClient";
import { useNavigate } from "react-router-dom";

const SignUpDialog = ({ open, onClose }) => {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      await apiClient.post("/register", {
        id: email,
        email: email,
        fullname: fullname,
        password: password,
        client_base_url: window.location.origin,
      });
      setMessage("Check your email for a verification link. Click the link to verify your email address. If you don’t see the email in your inbox, be sure to check your spam or junk folder.");
      setErrorMessage("");
      setIsSubmitted(true);
      setTimeout(() => {
        onClose();
        navigate("/login");
      }, 5000);
    } catch (error) {
      // apiClient now extracts the error detail, so just use error.message
      setErrorMessage(error.message || "Sign up failed. Please try again.");
      setMessage("");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Sign Up</DialogTitle>
      <form onSubmit={handleSignUp}>
        <DialogContent>
          {message && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}
          {errorMessage && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          )}
          {!isSubmitted && (
            <>
              <TextField
                margin="dense"
                label="Full Name"
                type="text"
                fullWidth
                required
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
              />
              <TextField
                margin="dense"
                label="Email Address"
                type="email"
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <PasswordField
                value={password}
                onChange={setPassword}
                confirmValue={confirmPassword}
                confirmOnChange={setConfirmPassword}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          {!isSubmitted && (
            <>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="contained">
                Sign Up
              </Button>
            </>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default SignUpDialog;
